// extracted by mini-css-extract-plugin
export default {"cardListSkeleton":"cardListSkeleton_cardListSkeleton__7RIvg","skeleton":"cardListSkeleton_skeleton__s8-0K","skeleton-animation":"cardListSkeleton_skeleton-animation__YWeVQ"};